var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AdminPage',[_c('template',{slot:"header"},[_vm._v(_vm._s(_vm.$t('content.errors.title')))]),_c('ErrorList',{attrs:{"errors":_vm.admin_errorlogs,"loading":_vm.$apollo.queries.admin_errorlogs.loading}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }